import React from 'react'
import { node, string, func, bool } from 'prop-types'
import styled from 'styled-components'
import { stripUnit, rgba } from 'polished'

import { white, borderColor } from 'styles/colors'
import { animationTime, animationCurve, borderRadius } from 'styles/global'
import { fontWeights, Lead } from 'styles/typography'
import * as spacing from 'styles/spacing'
import { media } from 'styles/media'
import Icon from 'components/Icon'

import DownChevron from 'icons/down-chevron.svg'

const Container = styled.div`
  position: relative;
  background-color: ${rgba(white, 0.1)};
  border-radius: ${borderRadius};

  & + & {
    margin-top: ${spacing.medium};
  }
`

const Trigger = styled.button`
  display: flex;
  width: 100%;
  text-align: left;
  color: ${white};
  padding: ${spacing.large};

  ${media.small`
    padding: ${spacing.xLarge};
  `};

  ${media.large`
    padding: ${spacing.xxLarge};
  `};
`

const Title = styled(Lead)`
  flex-grow: 1;
  padding-right: ${spacing.medium};
  margin-bottom: 0;
  color: ${white};
  font-weight: ${fontWeights.bold};

  ${media.medium`
    padding-right: ${spacing.large};
  `};
`

const IconWrap = styled.div`
  display: flex;
  flex-shrink: 0;
  transition: color ${animationTime} ${animationCurve}, transform ${animationTime} ${animationCurve};
  transform: ${props => (props.flipped ? 'rotate(180deg)' : 'none')};
`

const Answer = styled.div`
  color: ${borderColor};
  padding: ${spacing.large};
  margin-top: -${spacing.small};
  padding-top: 0 !important;

  p a {
    color: ${white};
  }

  ${media.small`
    padding: ${spacing.xLarge};
  `};

  ${media.medium`
    margin-top: -${stripUnit(spacing.small) * 1.5 + 'px'};
  `};

  ${media.large`
    padding: ${spacing.xxLarge};
    margin-top: -${spacing.medium};
  `};
`

const Question = ({ question, expanded, handleClick, children, id }) => (
  <Container id={id}>
    <Trigger onClick={handleClick}>
      <Title>{question}</Title>
      <IconWrap flipped={expanded ? 'true' : undefined}>
        <Icon icon={<DownChevron />} />
      </IconWrap>
    </Trigger>
    {expanded ? <Answer>{children}</Answer> : null}
  </Container>
)

Question.propTypes = {
  id: string.isRequired,
  children: node.isRequired,
  question: string.isRequired,
  handleClick: func.isRequired,
  expanded: bool
}

export default Question
